import classNames from 'classnames';
import React from 'react';
import './index.scss';
import MetricsCard from '@/pages/dashboard/components/MetricsCard';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';

export default function ForecastMetricCard(props: any) {

  const { className, titleEn, titleCn,tipEn, tipCn, isIconTips,nodataMsg,imgUrl,formatRule, metricKey, data, preUnit="", endUnit="" } = props;
  const { cards } = data;
  const metricData = cards?.[metricKey] || {};
  const minValue = metricData.value || '';
  const maxValue = metricData.value_ext1 || '';

  // 数据展示
  let displayValue = '-';

  const min = minValue  ? dataFormat({ value: minValue, formatRule }) : '';
  const max = maxValue  ? dataFormat({ value: maxValue, formatRule }) : '';
  
  if (min && max) {
    displayValue = `${preUnit}${min}${endUnit} ~ ${preUnit}${max}${endUnit}`;
  } else if (min) {
    displayValue = `${preUnit}${min}${endUnit}`;
  } else if (max) {
    displayValue = `${preUnit}${max}${endUnit}`;
  }

  return (
    <MetricsCard
      titleEn={titleEn}
      titleCn={titleCn}
      tipsEn={tipEn}
      tipsCn={tipCn}
      isIconTips={isIconTips}
      className={classNames('dbd-forecast-metric-card', className)}
      nodataMsg={nodataMsg}
      imgUrl={imgUrl}
      formatRule={formatRule}
      value={displayValue}
    >
    </MetricsCard>
  );
}
